module.exports = __webpack_public_path__ + "img/fundas.da6aef2d.png";